import { Alert, Box, BoxList, Icon, Text } from '@factorialco/deprecated-design-system'
import {
  AtUpdateUnassignedHiringPhaseStageDocument,
  AtUpdateUnassignedHiringPhaseStageMutation,
  AtsGetHiringPipelineStagesDocument,
  AtsUnassignedHiringPhaseFragment,
} from 'generated/resources/graphql'
import { groupBy } from 'lodash'

import Select from 'modules/core/components/Select'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { UNASSIGNED_STAGE, editableStagesOptions } from 'modules/ats/lib/utils/hiringStages'

interface Props {
  unassignedPhases: AtsUnassignedHiringPhaseFragment[]
}
export const UnassignedHiringPhases = ({ unassignedPhases }: Props) => {
  const { data: hiringStagesData } = useQuery(AtsGetHiringPipelineStagesDocument)

  const hiringStages = hiringStagesData?.ats.hiringStagesConnection.nodes || []

  const [changeHiringStageAtsApplicationPhase] = useMutation(
    AtUpdateUnassignedHiringPhaseStageDocument,
    {
      extractorFn: (data: AtUpdateUnassignedHiringPhaseStageMutation) =>
        data.atsMutations.changeHiringStageAtsApplicationPhase,
    }
  )

  const onChange = async (id: number, atsHiringStageId: number) => {
    const result = await changeHiringStageAtsApplicationPhase({
      variables: {
        id,
        atsHiringStageId,
      },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
    }

    return handled
  }

  const getEditableApplicationPhases = (phases: AtsUnassignedHiringPhaseFragment[]) => {
    return phases.filter((phase) => phase.phaseType != 'initial' && phase.phaseType != 'hired')
  }

  const stagePhasesGroups = groupBy(
    getEditableApplicationPhases(unassignedPhases),
    (phase) => phase.hiringStage?.name || 'unassigned'
  )

  return (
    <Box gap="s32" paddingBottom="s16">
      <Alert color="error">
        <Icon.Medium icon="alert-circle" color="grey800" />
        <Text.Normal>
          {i18n.t('ats.job_posting_settings.hiring_pipeline.ununassigned_phases.warning_message')}
        </Text.Normal>
      </Alert>

      <BoxList>
        {stagePhasesGroups[UNASSIGNED_STAGE]?.map((item, index) => (
          <BoxList.Item key={`unassigned-${index}`}>
            <Text.Normal weight="medium">{item.name}</Text.Normal>
            <Box width="s200">
              <Select
                aria-label={i18n.t(
                  'ats.job_posting_settings.hiring_pipeline.ununassigned_phases.select_label'
                )}
                none={i18n.t(
                  'ats.job_posting_settings.hiring_pipeline.ununassigned_phases.select_label'
                )}
                defaultOption={undefined}
                options={editableStagesOptions(hiringStages)}
                onChange={(value) => onChange(item.id, Number(value))}
              />
            </Box>
          </BoxList.Item>
        ))}
      </BoxList>
    </Box>
  )
}
